import { useMemo } from 'react'
import { type WarehouseLocation } from 'legacy/common/types'
import { type WarehouseContextValue } from 'utils/contexts/warehouse/WarehouseContext'
import { filterPickupWarehouseLocations } from 'domains/pickup-settings'

export const useValidWarehouseLocations: (
  warehouseContext: WarehouseContextValue
) => WarehouseLocation[] = warehouseContext =>
  useMemo(() => {
    if (!warehouseContext.loaded) {
      return []
    }

    const allWarehouseLocations = [
      ...warehouseContext.warehouse.warehouseLocations,
      ...warehouseContext.warehouse.inactiveWarehouseLocations,
    ]

    // For Aldi, we manually pin their "ALDI - Pickup Test" location to the top of the locations dropdown list
    // Related thread: https://instacart.slack.com/archives/C01N67FSMRQ/p1631805659066100
    const stickyLocations = ['26992']
    return allWarehouseLocations
      .filter(filterPickupWarehouseLocations)
      .sort(({ id }) => (stickyLocations.includes(id) ? -1 : 0)) //We push locations from stickyLocations at the top of the resulting array
  }, [
    warehouseContext.loaded,
    warehouseContext.warehouse.inactiveWarehouseLocations,
    warehouseContext.warehouse.warehouseLocations,
  ])
